import { createAction } from 'redux-actions';

import { CHANGE_ENTITY, CHANGE_STATS } from './types';

export const changeEntity = createAction(CHANGE_ENTITY);

export const changeStats = createAction(CHANGE_STATS);
